import {PropertyDefinitionConfig} from '../types';

// TODO: it doesn't look right fitting this into something that's called PropertyDefinitionConfig. Maybe should rethink type name.
export const REPOSITORY_ENTRY_REPOSITORY: PropertyDefinitionConfig = {
	id: 'idEntryRepository',
	singular: 'Repository entry',
	summary: 'Represents an entry in a repository.',
};
